// import DsfAuditState from './auditState.vue'
//已经在路由中引入不必此处再引入
// import DsfStatsAuditFormulaForm from './formulaForm.vue'

const components = {
  DsfAuditState: dsf.defineAsyncComponent("DsfAuditState", () => import(/*webpackChunkName:"platform_form"*/"./auditState.vue"))
  // DsfStatsAuditFormulaForm
};

function install(Vue) {
  for (let key in components) {
    let it = components[key];
    let name = dsf.isFunction(it) ? it.ctrlName || key : it.name;
    Vue.component(name, it);
    if (!window.$components["platform"]) {
      window.$components["platform"] = {};
    }
    window.$components["platform"][name] = it;
  }
}

export { install };
export default install;
